import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Select, TextInput } from 'components/Form'
import { createApiRecord, updateApiRecord } from 'services/CustomersService'
import { useDispatch, useSelector } from 'react-redux'
import { getRecord } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import { getCustomersData } from 'store/data/dataSlice'
import { Tabs } from 'components/Ui'
import OrderTypeTabView from './components/OrderTypeTabView'
import WarehouseTabView from './components/WarehouseTabView'
import SftpConfigurationTabView from './components/SftpConfigurationTabView'
import ShopifyIntegrationTabView from './components/ShopifyIntegrationTabView'
import WooCommerceIntegrationTabView from './components/WooCommerceIntegrationTabView'
injectReducer('customers', reducer)

const validationSchema = Yup.object().shape({
    company: Yup.string().required('company field is required.'),
    customer_code: Yup.string().required('code field is required.'),
})

const Create = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { companyData, customersData, integrationData } = useSelector(state => state.listData)
    const { view, record, loading } = useSelector(state => state.customers.data)

    useEffect(() => {
        if (id) {
            fetchData(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const fetchData = id => dispatch(getRecord(id))

    const handleDiscard = () => navigate('/company-management/customers')

    const handleSubmit = data => {
        if (id) {
            updateApiRecord(id, data)
                .then(() => {
                    Success('Customer Updated Successfully!')
                    // handleDiscard()
                    dispatch(getCustomersData())
                })
                .catch(error => console.log('Error: ', error))
        } else {
            createApiRecord(data)
                .then(response => {
                    Success('Customer Created Successfully!')
                    // handleDiscard()
                    navigate(`/company-management/customers/${response?.data?.id}/edit`)
                    dispatch(getCustomersData())
                })
                .catch(error => console.log('Error: ', error))
        }
    }

    if (loading && id) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Customers</h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                            {id ? 'Update Customers' : 'Add New Customers'}
                        </h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={
                                id
                                    ? {
                                          ...record,
                                          company: typeof record?.company === 'object' ? record?.company?.id : record?.company,
                                      }
                                    : view
                            }
                            validationSchema={validationSchema}
                            onSubmit={values => {
                                handleSubmit(values)
                            }}
                        >
                            {({ values, touched, errors }) => (
                                <Form>
                                    <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
                                        <Field name="company">
                                            {({ field, form }) => (
                                                <Select
                                                    id="company"
                                                    name="company"
                                                    label="Company"
                                                    placeholder="Company"
                                                    value={values?.company}
                                                    options={companyData}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    error={touched.company && errors.company}
                                                    message={errors.company}
                                                />
                                            )}
                                        </Field>
                                        {/* <Field name="customer_id">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="Customer Id"
                                                    name="customer_id"
                                                    error={errors.customer_id && touched.customer_id}
                                                    message={errors.customer_id}
                                                    value={values?.customer_id}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field> */}
                                        <Field name="customer_code">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="Customer Code"
                                                    name="customer_code"
                                                    error={errors.customer_code && touched.customer_code}
                                                    message={errors.customer_code}
                                                    value={values?.customer_code}
                                                    onChange={e => {
                                                        form.setFieldValue(field.name, e.target.value)
                                                        form.setFieldValue('customer_id', e.target.value)
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        {/* <Field name="customer_type">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="Customer Type"
                                                    name="customer_type"
                                                    error={errors.customer_type && touched.customer_type}
                                                    message={errors.customer_type}
                                                    value={values?.customer_type}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field> */}
                                        <Field name="contact1">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="Contact Name"
                                                    name="contact1"
                                                    error={errors.contact1 && touched.contact1}
                                                    message={errors.contact1}
                                                    value={values?.contact1}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field>
                                        <Field name="contact1Email">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="Contact Email"
                                                    name="contact1Email"
                                                    error={errors.contact1Email && touched.contact1Email}
                                                    message={errors.contact1Email}
                                                    value={values?.contact1Email}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field>
                                        <Field name="contact1Tel1">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="Contact Phone Number"
                                                    name="contact1Tel1"
                                                    error={errors.contact1Tel1 && touched.contact1Tel1}
                                                    message={errors.contact1Tel1}
                                                    value={values?.contact1Tel1}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field>
                                        {/* <Field name="contact1Title">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="Contact Title"
                                                    name="contact1Title"
                                                    error={errors.contact1Title && touched.contact1Title}
                                                    message={errors.contact1Title}
                                                    value={values?.contact1Title}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field>
                                        <Field name="country">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="Country"
                                                    name="country"
                                                    error={errors.country && touched.country}
                                                    message={errors.country}
                                                    value={values?.country}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field>
                                        <Field name="province">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="State"
                                                    name="province"
                                                    error={errors.province && touched.province}
                                                    message={errors.province}
                                                    value={values?.province}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field>
                                        <Field name="city">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="City"
                                                    name="city"
                                                    error={errors.city && touched.city}
                                                    message={errors.city}
                                                    value={values?.city}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field>
                                        <Field name="zip_code">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="Postal Code"
                                                    name="zip_code"
                                                    error={errors.zip_code && touched.zip_code}
                                                    message={errors.zip_code}
                                                    value={values?.zip_code}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field> */}
                                        <Field name="machship_code">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    label="Machship Code"
                                                    name="machship_code"
                                                    error={errors.machship_code && touched.machship_code}
                                                    message={errors.machship_code}
                                                    value={values?.machship_code}
                                                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                    {id ? (
                        <div className="px-5 py-3 border-t border-stroke dark:border-strokedark">
                            <Tabs.Group version={1}>
                                <Tabs.List>
                                    <Tabs>Order Type</Tabs>
                                    <Tabs>Warehouse</Tabs>
                                    <Tabs>SFTP Configuration</Tabs>
                                    <Tabs>Shopify Integration</Tabs>
                                    <Tabs>WooCommerce Integration</Tabs>
                                </Tabs.List>
                                <Tabs.Panels className="mt-4">
                                    <Tabs.Panel>
                                        <OrderTypeTabView
                                            companyData={companyData}
                                            customersData={customersData}
                                            record={record}
                                        />
                                    </Tabs.Panel>
                                    <Tabs.Panel>
                                        <WarehouseTabView
                                            companyData={companyData}
                                            customersData={customersData}
                                            record={record}
                                        />
                                    </Tabs.Panel>
                                    <Tabs.Panel>
                                        <SftpConfigurationTabView
                                            integrationData={integrationData.filter(item => item.customer === record?.id)}
                                            record={record}
                                        />
                                    </Tabs.Panel>
                                    <Tabs.Panel>
                                        <ShopifyIntegrationTabView
                                            companyData={companyData}
                                            customersData={customersData}
                                            record={record}
                                        />
                                    </Tabs.Panel>
                                    <Tabs.Panel>
                                        <WooCommerceIntegrationTabView
                                            companyData={companyData}
                                            customersData={customersData}
                                            record={record}
                                        />
                                    </Tabs.Panel>
                                </Tabs.Panels>
                            </Tabs.Group>
                        </div>
                    ) : null}
                </div>
            </div>
        </>
    )
}

export default Create
